import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { setFormData } from '../redux/action';
import ReactLib from '@owenscorning/react-library'


const { Connect: { Spinner, ReactUtils: { useDebounce, useLoading }, FormElements: { Form, Text } } } = ReactLib
const apiUrl = (value) => `${MDMS_URL}/api/v1/warranty_claims/contractor_portal_lookup?email=${encodeURIComponent(value.toLowerCase())}`
const fieldKey = 'installingContractor'
const dataKey = 'installingContractorData'
const elId = 'installing-contractor-input'
const minQueryLength = 3

const contractorObjectToString = (obj) => {
  const { company_name, first_name, last_name } = obj
  return `${company_name || ''}: ${first_name || ''} ${last_name || ''}`
}

const ContractorSearch = ({ formData, setFormData }) => {
  const didMount = useRef(false);
  const { installingContractor, foundContractor } = formData
  const [loadWrapper, loading, loadError] = useLoading()
  const [contractors, setContractors] = useState({});
  const [isSearchDone, setIsSearchDone] = useState(false)
  const fetchContractors = loadWrapper(async (searchValue) => {
      console.log('sending contractor search request', searchValue)
      const response = await fetch(apiUrl(searchValue)).then(response => response.json())
      // console.log('response', response)

      setFormData({foundContractor: response?.status})
      if(response?.status){
        setContractors(response?.user)
      }
      setIsSearchDone(true)
    })
  const [debounceFetch, cancelDebounceFetch] = useDebounce(fetchContractors)

  const onTextChange = (nextVal) => {
    setFormData({ [fieldKey]: nextVal })
    if (nextVal.length >= minQueryLength) { debounceFetch(nextVal) }
  }

  if (loadError) {
    console.error(loadError.stack);
    throw loadError;
  }

  return (
    <div>
      <Text
        value={installingContractor}
        onChange={onTextChange}
        htmlAttributes={{
          placeholder: 'Search Contractors',
          list: elId
        }}
      />
      {loading && <Spinner />}
      {/* <datalist id={elId}>
        <option>
            {contractorObjectToString(contractors)}
          </option>
      </datalist> */}
      {!foundContractor && isSearchDone && <p>Contractor not found</p>}
      {foundContractor && isSearchDone && <p>Contractor found: {contractorObjectToString(contractors)}</p>}
    </div>
  )
}

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const mapDispatchToProps = dispatch => (
  {
    setFormData: (hash) => dispatch(setFormData(hash)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorSearch);
